<div class="fuse-vertical-navigation-wrapper">
  <!-- Content -->
  <div id="sidebarNavigationContent" class="fuse-vertical-navigation-content" #navigationContent>
    <!-- Content header -->
    <div class="fuse-vertical-navigation-content-header">
      <ng-content select="[fuseVerticalNavigationContentHeader]"></ng-content>
    </div>

    <!-- Items -->
    <ng-container *ngFor="let item of navigation; trackBy: trackByFn">
      <!-- Basic -->
      <ng-container *ngIf="item.type === 'basic'">
        <app-basic-item [item]="item" [isChild]="false" (click)="close()"></app-basic-item>
      </ng-container>

      <!-- Collapsable -->
      <ng-container *ngIf="item.type === 'collapsable'">
        <app-collapsable-item
          [item]="item"
          [name]="sidebarName"
          [autoCollapse]="autoCollapse"
          (closeNav)="close()"
        ></app-collapsable-item>
      </ng-container>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="fuse-vertical-navigation-footer">
    <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>
  </div>
</div>
